import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import Equalizer from './Equalizer';
import './Music.css';
import { audioCtx, analyser } from './audioContext';
import { songsData } from './songsData';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      songs: [],
      currentAlbumId: 1,
      currentSongIndex: 0,
      loading: true,
      isPlayerOpen: false,
      audioSource: null
    };
    this.audioRef=createRef();
    this.letsplay=this.letsplay.bind(this);
    this.togglePlayer=this.togglePlayer.bind(this);
    this.audioListenerAdded=false;
    this.updateSongLinks=this.updateSongLinks.bind(this);
  }

  componentDidMount(){
    this.fetchSongs();
    this.letsplay();
    this.updateSongLinks();
    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('state');
    
    if (stateParam) {
        try {
            const state = JSON.parse(decodeURIComponent(stateParam));
            if (state && state.albumId) {
                this.setState({
                    currentAlbumId: state.albumId,
                    currentSongIndex: 0 // Начинаем с первой песни выбранного альбома
                }, () => {
                    this.updateSongLinks(); // Обновляем ссылки под конкретный альбом
                });
            }
        } catch (e) {
            console.error("Ошибка парсинга состояния из URL", e);
        }
    }
  }

  letsplay() {
    setTimeout(()=>{
      const audiosong=document.querySelector('.player_button_open');
      if (audiosong) {
        if (!this.audioListenerAdded) {
          audiosong.addEventListener('click',this.togglePlayer);
          this.audioListenerAdded=true;
        }
      };
    }, 900);
  }

  togglePlayer = () => {
    const { isPlayerOpen, audioSource } = this.state;
  
    const musicCols = document.querySelectorAll('.music_col');
    const playerFull = document.querySelector('.player_full');
    const elemsToBlur = document.querySelectorAll('.music_back, .black_background');
    const elemsNoBlur = document.querySelectorAll('.player, .player_open_button');
  
    if (isPlayerOpen) {
      playerFull.classList.remove('fade-in');
      playerFull.classList.add('fade-out');
  
      setTimeout(() => {
        musicCols.forEach(element => {
          element.classList.remove('hideit');
        });
  
        if (playerFull) {
          playerFull.classList.add('hide');
          playerFull.classList.remove('fade-out');
        }
  
        elemsToBlur.forEach(el => {
          el.style.filter = 'none';
        });
  
        elemsNoBlur.forEach(el => {
          el.classList.remove('blur');
        });
  
        this.setState({ isPlayerOpen: false });
  
        const audioElement = this.audioRef.current;
        if (audioElement) {
          audioElement.pause();
          audioElement.currentTime = 0;
        }
      }, 500); // Длительность анимации
    } else {
      if (!audioSource) {
        try {
          const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          const analyser = audioCtx.createAnalyser();
          analyser.fftSize = 256;
          const source = audioCtx.createMediaElementSource(this.audioRef.current);
          source.connect(analyser);
          analyser.connect(audioCtx.destination);
          this.setState({ audioSource: source, audioCtx: audioCtx, analyser: analyser });
  
          if (audioCtx.state === 'suspended') {
            audioCtx.resume();
          }
        } catch (error) {
          console.error('Ошибка при создании MediaElementSource:', error);
        }
      }
  
      musicCols.forEach(element => {
        element.classList.add('hideit');
      });
  
      if (playerFull) {
        playerFull.classList.remove('hide');
        playerFull.classList.remove('fade-out');
        playerFull.classList.add('fade-in');
      }
  
      elemsToBlur.forEach(el => {
        el.style.filter = 'blur(10px)';
      });
  
      elemsNoBlur.forEach(el => {
        el.classList.remove('blur');
      });
  
      this.setState({ isPlayerOpen: true });
  
      const audioElement = this.audioRef.current;
      if (audioElement) {
        audioElement.addEventListener('play', () => {
          this.setState({ isPlayerOpen: true });
        });
  
        audioElement.addEventListener('playing', () => {});
        audioElement.addEventListener('pause', () => {});
        audioElement.addEventListener('ended', () => {});
      }
    }
  }
  
  componentWillUnmount() {
    const audioplayer=document.querySelector('.player_controller');
    if (audioplayer) {
      audioplayer.removeEventListener('play',this.handlePlay);
    };
  }

  fetchSongs() {
    this.setState({ 
        songs: songsData, 
        loading: false 
    });
  }

  formatAlbum(album) {
    return String(album).padStart(2,'0');
  }

  selectsong(e,mus) {
    e.preventDefault();
    window.open(mus,'_blank','noopener,noreferrer');
  }

  handlePrevAlbum=()=>{
    this.fadeOutCurrentAlbum(() => {
      this.setState(prevState=>{
        const uniqueAlbumIds = [...new Set(prevState.songs.map(song => song.albumid))];
        const currentAlbumIndex = uniqueAlbumIds.indexOf(prevState.currentAlbumId);
        const prevAlbumIndex = (currentAlbumIndex - 1 + uniqueAlbumIds.length) % uniqueAlbumIds.length;
        const prevAlbumId = uniqueAlbumIds[prevAlbumIndex];
        const songsInPrevAlbum = prevState.songs.filter(song => song.albumid === prevAlbumId);
        const newSongIndex = Math.min(prevState.currentSongIndex, songsInPrevAlbum.length - 1);
        return {
          currentAlbumId: prevAlbumId,
          currentSongIndex: newSongIndex
        };
      },()=> {
        this.fadeInCurrentAlbum();
      });
    })
  }

  handleNextAlbum=()=>{
    this.fadeOutCurrentAlbum(() => {
      this.setState(prevState=>{
        const uniqueAlbumIds = [...new Set(prevState.songs.map(song => song.albumid))];
        const currentAlbumIndex = uniqueAlbumIds.indexOf(prevState.currentAlbumId);
        const nextAlbumIndex = (currentAlbumIndex + 1) % uniqueAlbumIds.length;
        const nextAlbumId = uniqueAlbumIds[nextAlbumIndex];
        const songsInNextAlbum = prevState.songs.filter(song => song.albumid === nextAlbumId);
        const newSongIndex = Math.min(prevState.currentSongIndex, songsInNextAlbum.length - 1);
        return {
          currentAlbumId: nextAlbumId,
          currentSongIndex: newSongIndex
        };
      },()=> {
        this.fadeInCurrentAlbum();
      });
    });
  }

  fadeOutCurrentAlbum(callback) {
    const blackBackground = document.querySelector('.black_background');
    blackBackground.classList.add('active');
    const currentAlbumElements = document.querySelectorAll('.music_back.current');
    currentAlbumElements.forEach(el => {
      el.style.transition = 'opacity 0.5s ease';
      el.style.opacity = '0';
    });
    setTimeout(callback, 500);
  }

  fadeInCurrentAlbum() {
    const blackBackground = document.querySelector('.black_background');
    blackBackground.classList.remove('active');
    const currentAlbumElements = document.querySelectorAll('.music_back.current');
    currentAlbumElements.forEach(el => {
      el.style.transition = 'opacity 0.5s ease';
      el.style.opacity = '1';
    });
  }

  handlePrevSong = () => {
    const songElements = document.querySelectorAll('.music_song_chapter');
    songElements.forEach(el => {
      el.classList.add('fade-out-down');
    });
    setTimeout(() => {
      this.setState(prevState => {
        const songsInAlbum = prevState.songs.filter(song => song.albumid === prevState.currentAlbumId);
        const newSongIndex = (prevState.currentSongIndex - 1 + songsInAlbum.length) % songsInAlbum.length;
        return { currentSongIndex: newSongIndex };
      }, () => {
        this.updateSongLinks();
        songElements.forEach(el => {
          el.classList.remove('fade-out-down');
          el.classList.add('fade-in-up');
        });
      });
    },500);
  }
  
  handleNextSong = () => {
    const songElements = document.querySelectorAll('.music_song_chapter');
    songElements.forEach(el => {
      el.classList.add('fade-out-down');
    });
    setTimeout(() => {
      this.setState(prevState => {
        const songsInAlbum = prevState.songs.filter(song => song.albumid === prevState.currentAlbumId);
        const newSongIndex = (prevState.currentSongIndex + 1) % songsInAlbum.length;
        return { currentSongIndex: newSongIndex };
      }, () => {
        this.updateSongLinks();
        songElements.forEach(el => {
          el.classList.remove('fade-out-down');
          el.classList.add('fade-in-up');
        });
      });
    },500);
  }
  
  updateSongLinks = () => {
    const { songs, currentAlbumId, currentSongIndex } = this.state;
    const songsInCurrentAlbum = songs.filter(song => song.albumid === currentAlbumId);
    const currentSong = songsInCurrentAlbum[currentSongIndex] || songsInCurrentAlbum[0];
    document.querySelectorAll('.musicsocies_link.yt').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.youtube);
    });
    document.querySelectorAll('.musicsocies_link.de').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.deezer);
    });
    document.querySelectorAll('.musicsocies_link.vk').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.vk);
    });
    document.querySelectorAll('.musicsocies_link.sp').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.spotify);
    });
    document.querySelectorAll('.musicsocies_link.ya').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.yandex);
    });
    document.querySelectorAll('.musicsocies_link.ap').forEach(link => {
      link.onClick = (e) => this.selectsong(e, currentSong.apple);
    });
  }

  handlePlay = () => {
    const audioElement = this.audioRef.current;
    if (audioElement) {
      audioElement.play();
    }
  }
  
  handlePause = () => {
    const audioElement = this.audioRef.current;
    if (audioElement) {
      audioElement.pause();
    }
  }
  
  render() {
    const { songs, currentAlbumId, currentSongIndex, loading, isPlayerOpen } = this.state;
    if (loading) {
      return <div>Loading...</div>
    }
    const uniqueAlbumIds = [...new Set(songs.map(song=>song.albumid))];
    const prevAlbumId = uniqueAlbumIds[(uniqueAlbumIds.indexOf(currentAlbumId)-1+uniqueAlbumIds.length)%uniqueAlbumIds.length];
    const nextAlbumId = uniqueAlbumIds[(uniqueAlbumIds.indexOf(currentAlbumId)+1)%uniqueAlbumIds.length]
    const currentAlbums = [
      songs.find(song=>song.albumid===prevAlbumId),
      songs.find(song=>song.albumid===currentAlbumId),
      songs.find(song=>song.albumid===nextAlbumId)
    ];
    
    const songsInCurrentAlbum = songs.filter(song=>song.albumid===currentAlbumId);
    const currentSong = songsInCurrentAlbum[currentSongIndex] || songsInCurrentAlbum[0];

    return (
      <div className="main">
        <div className='black_background'></div>
        {/* <div className='music_content'> */}
        <section>
          {currentAlbums.map((album, index)=>(
            <div key={index} className={`music_back ${album.albumid === currentAlbumId ? 'current' : ''}`} style={{ backgroundImage: `url(${album.background})` }}>
              <div className='music_circles'>
                <div className='music_col'>
                  <div className='music_left'>
                    <div className='music_socies'>
                      {album.youtube && <Link to='' className='musicsocies_link yt' onClick={(e) => this.selectsong(e,`${currentSong.youtube}`)}/>}
                      {album.deezer && <Link to='' className='musicsocies_link de' onClick={(e) => this.selectsong(e,`${currentSong.deezer}`)}/>}
                      {album.vk && <Link to='' className='musicsocies_link vk' onClick={(e) => this.selectsong(e,`${currentSong.vk}`)}/>}
                      {album.spotify && <Link to='' className='musicsocies_link sp' onClick={(e) => this.selectsong(e,`${currentSong.spotify}`)}/>}
                      {album.yandex && <Link to='' className='musicsocies_link ya' onClick={(e) => this.selectsong(e,`${currentSong.yandex}`)}/>}
                      {album.apple && <Link to='' className='musicsocies_link ap' onClick={(e) => this.selectsong(e,`${currentSong.apple}`)}/>}
                    </div>
                    <p className='music_album_number'>{this.formatAlbum(album.albumid)}</p>
                    <p className='music_album_name'>{album.namealbum}</p>
                    <div className='music_album_chapters'>
                      <p className='music_album_all'>Альбомы</p>
                      <div className='music_album_cols'>
                        <div className='music_album_chapter lil'>
                          {prevAlbumId && <img src={songs.find(song => song.albumid === prevAlbumId).image} alt='' />}
                        </div>
                        <button onClick={this.handlePrevAlbum} className='carousel prev' />
                        <div className='music_album_chapter'>
                          <img src={album.image} alt='' />
                        </div>
                        <button onClick={this.handleNextAlbum} className='carousel next' />
                        <div className='music_album_chapter lil'>
                          {nextAlbumId && <img src={songs.find(song => song.albumid === nextAlbumId).image} alt='' />}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='music_right'>
                    <div className='music_song_chapters'>
                      <p className='music_song_all'>Песни</p>
                      <div className='music_song_cols'>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex - 1 + songsInCurrentAlbum.length) % songsInCurrentAlbum.length].name)&&
                        <div className='music_song_chapter lil fade-in-up'>
                          {prevAlbumId && <img src={album.image} alt='' />}
                          {prevAlbumId && <p className='music_song_name lil'>{songsInCurrentAlbum[(currentSongIndex - 1 + songsInCurrentAlbum.length) % songsInCurrentAlbum.length].name}</p>}
                        </div>}
                        <div className='music_song_chapter fade-in-up'>
                          <img src={album.image} alt='' />
                          <p className='music_song_name'>{currentSong.name}</p>
                        </div>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex + 1) % songsInCurrentAlbum.length].name)&&
                        <div className='music_song_chapter lil fade-in-up'>
                          {nextAlbumId && <img src={album.image} alt='' />}
                          {nextAlbumId && <p className='music_song_name lil'>{songsInCurrentAlbum[(currentSongIndex +1) % songsInCurrentAlbum.length].name}</p>}
                        </div>}
                      </div>
                      <div className='player'>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex - 1 + songsInCurrentAlbum.length) % songsInCurrentAlbum.length].name)&&<button onClick={this.handlePrevSong} className='player prev' />}
                        <audio className='player_controller' controls id="player" src={`../music/${currentAlbumId}-${currentSongIndex}.mp3`} type="audio/mpeg"></audio>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex +1) % songsInCurrentAlbum.length].name)&&<button onClick={this.handleNextSong} className='player next' />}
                      </div>
                    </div>
                    <p className='player_button_open no_blur' onClick={this.togglePlayer}>{isPlayerOpen ? 'закрыть плеер' : 'открыть плеер'}</p>
                    <div className='music_song_line_back'>
                      <p className='music_song_line'>{currentSong.line}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='music_circles1' />
              <div className='music_circles2' />
              <div className='music_circles3' />
              <div className='music_circles4' />
            </div>
          ))}
          <div className='player_full hide'>
            {currentAlbums.map((album, index)=>(
              <div key={index} className={`player_music_back ${album.albumid === currentAlbumId ? 'current' : ''}`}>
                <div className='player_music_col'>
                  <div className='player_music_socies'>
                    {album.youtube && <Link to='' className='musicsocies_link yt' onClick={(e) => this.selectsong(e,`${album.youtube}`)}/>}
                    {album.deezer && <Link to='' className='musicsocies_link de' onClick={(e) => this.selectsong(e,`${album.deezer}`)}/>}
                    {album.vk && <Link to='' className='musicsocies_link vk' onClick={(e) => this.selectsong(e,`${album.vk}`)}/>}
                    {album.spotify && <Link to='' className='musicsocies_link sp' onClick={(e) => this.selectsong(e,`${album.spotify}`)}/>}
                    {album.yandex && <Link to='' className='musicsocies_link ya' onClick={(e) => this.selectsong(e,`${album.yandex}`)}/>}
                    {album.apple && <Link to='' className='musicsocies_link ap' onClick={(e) => this.selectsong(e,`${album.apple}`)}/>}
                  </div>
                  <div className='player_music_album_chapters'>
                    <div className='player_music_album_cols'>
                      <button onClick={this.handlePrevAlbum} className='carousel prev' />
                      <div className='player_music_album_chapter'>
                        <p className='player_music_album_number'>{this.formatAlbum(album.albumid)}</p>
                        <p className='player_music_album_name'>{album.namealbum}</p>
                      </div>
                      <button onClick={this.handleNextAlbum} className='carousel next' />
                    </div>
                  </div>
                  {isPlayerOpen && this.audioRef && <Equalizer audioRef={this.audioRef} analyser={this.state.analyser} />}
                  <div className='player_music_right'>
                    <div className='player_music_song_chapters'>
                      <div className='player_music_song_cols'>
                        <div className='player_music_song_chapter'>
                          <p className='player_music_song_name'>{currentSong.name}</p>
                        </div>
                      </div>
                      <div className='player_player'>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex - 1 + songsInCurrentAlbum.length) % songsInCurrentAlbum.length].name)&&<button onClick={this.handlePrevSong} className='player prev' />}
                        <div className='player_controls'>
                          <button onClick={this.handlePlay} className='player_button_play' />
                          <button onClick={this.handlePause} className='player_button_pause' />
                        </div>
                        <audio ref={this.audioRef} className='player_player_controller' controls id="player" src={`../music/${currentAlbumId}-${currentSongIndex}.mp3`} type="audio/mpeg"></audio>
                        {currentSong.name!==(songsInCurrentAlbum[(currentSongIndex +1) % songsInCurrentAlbum.length].name)&&<button onClick={this.handleNextSong} className='player next' />}
                      </div>
                    </div>
                    <p className='player__full_button_open no_blur' onClick={this.togglePlayer}>закрыть плеер</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className='footer music no_blur'>
            <div className='footerleft'>
              <div className='footerleftline'>
                <Link to="" className='footerleftlinechapters vk' onClick={(e) => this.selectsong(e,'https://vk.com/lampabikt')} />
                <Link to=""  className='footerleftlinechapters yt' onClick={(e) => this.selectsong(e,'https://www.youtube.com/channel/UCpYDcaEQw6RQ-t_3CGidJuQ')} />
                <Link to=""  className='footerleftlinechapters tg' onClick={(e) => this.selectsong(e,'https://t.me/lampabikt')} />
                <Link to=""  className='footerleftlinechapters tt' onClick={(e) => this.selectsong(e,'https://www.tiktok.com/@lampabikt?is_from_webapp=1&sender_device=pc')} />
              </div>
              <div className='footerleftname'>
                <p className='footerleftnametext'>
                  лампабикт.
                </p>
              </div>
            </div>
            <div className='footercenter'>
              <a className='footercenterimg' />
            </div>
            <div className='footerright'>
              <div className='footerrightline'>
              <p className='footerrightlinetext'>ИКОНКИ ОТ <a className='footerrightlinetextlinkus' href='https://icons8.ru/icons' target='_blank' rel='noopener noreferrer'>ICONS8</a></p>
                <p className='footerrightlinetext'>СВЯЗАТЬСЯ С НАМИ: <a className='link_to_email' href="mailto:lampabikt@gmail.com">LAMPABIKT@GMAIL.COM</a></p>
                <p className='footerrightlinetext'>МЕНЕДЖЕР: АЛЕКСАНДРА</p>
              </div>
            </div>
          </div>
        </section>
      {/* </div> */}
      </div>
    );
  };
};